module.exports = __webpack_public_path__ + "static/media/Icon_right.4ef0b13d.svg";